export const ApplicationId = process.env.REACT_APP_APPLICATION_ID;
export const ContactApplicationId = process.env.REACT_APP_CONTACT_APPLICATION_ID;

export const vizybilityConfig = {
  STS_SIGNIN_URL: "https://sts.vizybility.net/connect/token",
  STS_CLIENT_ID: process.env.REACT_APP_STS_CLIENT_ID,
  STS_CLIENT_SECRET: process.env.REACT_APP_STS_CLIENT_SECRET,
  STS_SCOPE: process.env.REACT_APP_STS_SCOPE,
  grant_type: "password",
};
// ? Machine List

export const URL = process.env.REACT_APP_URL;
export const WEBURL = process.env.REACT_APP_WEB_URL;

export const POST_CONTACT_US = `${WEBURL}DealerWebApp/SendContactEmail`;
